// @flow
import * as React from 'react'
import is from 'mz-utils/is'
import BaseField from '../../../core/BaseField'
import Input from '../../../core/Input'
import DesktopSelectField from '../DesktopSelectField'
import { FieldWrapper, SelectField } from './elements'

// Types
import type { Props as SelectFieldProps } from '../DesktopSelectField'

export type Props = SelectFieldProps

/**
 * Simple pretty select input field that can be used to showed
 * simple selectors.
 */
class NativeSelectField extends React.Component<Props> {
  static defaultProps = DesktopSelectField.defaultProps

  // eslint-disable-next-line class-methods-use-this
  hideOptions() {
    // do nothing
  }

  renderOption(option: any) {
    const { renderOption, renderValue } = this.props
    const renderer = renderValue || renderOption
    return renderer(option, {})
  }

  handleChangeSelect = (e: any) => {
    const {
      input: { onChange },
    } = this.props
    const stringValue = e.target.value
    const options = this.props.options || []

    for (let i = 0; i < options.length; i++) {
      const stringOption = this.renderOption(options[i])
      if (stringValue === `${stringOption}`) {
        onChange && onChange(options[i], i)
        break
      }
    }
  }

  renderInput = ({ input, style, props, innerRef }: any) => {
    const { options } = this.props
    const value = is.undef(input.value) ? '' : this.renderOption(input.value)

    return (
      <FieldWrapper>
        <SelectField ref={innerRef} onChange={this.handleChangeSelect}>
          {!!options &&
            options.map((o, i) => {
              const stringOption = this.renderOption(o)
              return (
                <option key={i} value={stringOption}>
                  {stringOption}
                </option>
              )
            })}
        </SelectField>
        <Input
          input={{ ...input, value }}
          style={style}
          props={{
            ...props,
            type: 'static',
          }}
        />
      </FieldWrapper>
    )
  }

  render() {
    return (
      <BaseField {...this.props} renderInput={this.renderInput} type="select" />
    )
  }
}

export default NativeSelectField
